import { Column, ColumnConfig } from '@ant-design/plots';
import React from 'react';

type GroupedColumnPlotChartProps = {
    data: Record<string, any>[];
    config: (data: Record<string, any>[], colors: string[]) => ColumnConfig;
}

const GroupedColumnPlotChart = ({ data, config }: GroupedColumnPlotChartProps) => {

    const colors = [
        '#e67a3a',
        '#212121',
        '#f0a841'
    ];

    return (
        <Column {...config(data, colors)}/>
    )
}

export default GroupedColumnPlotChart;